@if (icon() && iconPosition() === 'left') {
  <ng-container [ngTemplateOutlet]="iconTemplate" />
}

@if (!hideText()) {
  <span class="button-text">
    <ng-content />
  </span>
}

@if (icon() && iconPosition() === 'right') {
  <ng-container [ngTemplateOutlet]="iconTemplate" />
}

<ng-template #iconTemplate>
  <accredible-icon
    [style.font-size]="iconSize()"
    [style.color]="iconColor()"
    [icon]="icon()"
    [@rotateAnimation]="rotateIcon() ? 'rotated' : 'initial'" />
</ng-template>

@if (isLoading()) {
  <accredible-icon [icon]="'loading'" class="animation-spin" />
}
